import React from 'react';
import styled from 'styled-components';

import ChevronIcon from '../../containers/assets/onboarding-chevron.png';

const Wrapper = styled.div`
  height: 80px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  width: calc(100% - 130px);
`;

const PrevButton = styled.a`
  img {
    margin-right: 5px;
  }

  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: rgba(0, 27, 59, 0.6);
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }

  ${(p) =>
    p.isHidden &&
    `
    visibility: hidden;
  `}
`;

const Text = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
`;

const NextButton = styled.a`
  &:active, &:visited, &:link {
    width: 160px;
    height: 40px;
    background: #5c91f5;
    border-radius: 4px;
    text-align: center;
    line-height: 40px;

    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;

    ${(p) =>
    !p.isDisabled &&
    !p.isLoadingMode &&
    `
      transition: background-color .4s ease-in-out;
    `}

    ${(p) =>
    (p.isDisabled || p.isLoadingMode) &&
    `
      pointer-events: none;
      color: rgba(0, 27, 59, 0.38);
      background: rgba(0, 27, 59, 0.08);
    `}

    ${(p) =>
    p.isValidationMode &&
    `
      color: #ffffff;
      background: #ec5e59;
    `}
  }

  &:hover {
    text-decoration: none;

    ${(p) =>
    !p.isDisabled &&
    !p.isValidationMode &&
    !p.isLoadingMode &&
    `
      background-color: #74a1f6;
    `}

    ${(p) =>
    p.isValidationMode &&
    `
      background-color: #ef7672;
    `}
  }
`;

const getNextTitle = (isLastStep, isNextDisabled, isValidationMode, isLoadingMode) => {
  if (isLastStep) {
    return 'Close';
  }

  if (isLoadingMode) {
    return 'Submitting...';
  }

  if (isNextDisabled || isValidationMode) {
    return 'Submit';
  }

  return 'Next';
};

const Pagination = ({
  currentStep,
  countOfSteps,
  goNext,
  goPrev,
  onValidate,
  isFirstStep,
  isLastStep,
  isNextDisabled,
  isValidationMode,
  isLoadingMode,
  isTriviaPage,
}) => (
  <Wrapper>
    <PrevButton href="#" onClick={goPrev} isHidden={isFirstStep || isTriviaPage}>
      <img src={ChevronIcon} alt="" />
      Previous
    </PrevButton>
    <Text>
      {currentStep}/{countOfSteps}
    </Text>
    <NextButton
      href="#"
      onClick={isValidationMode ? onValidate : goNext}
      isDisabled={isNextDisabled}
      isValidationMode={isValidationMode}
      isLoadingMode={isLoadingMode}
    >
      {getNextTitle(isLastStep, isNextDisabled, isValidationMode, isLoadingMode)}
    </NextButton>
  </Wrapper>
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/onboarding/Pagination.js